export default {
    title: '별 뽑기',
    labels: {
        inventory: '보유 아바타',
        machine: '별 뽑기 머신',
    },
    messages: {
        insufficientStars: '별이 부족해요. 😢',
        ctaText: '저를 눌러서 보관함에 넣어주세요!',
    },
};
